/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Rename_HelperInputs */

const en_us2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave it blank to go back to the suggested name.`)
};

const pt_br2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe em branco para voltar ao nome sugerido.`)
};

const es_419_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjalo en blanco para volver al nombre sugerido.`)
};

const pt_pt2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixa em branco para voltar ao nome sugerido.`)
};

const fr_fr2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laisse vide pour revenir au nom suggéré.`)
};

const de_de2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer lassen, um zum vorgeschlagenen Namen zurückzukehren.`)
};

const it_it2_plan_rename_helper = /** @type {(inputs: Plan_Rename_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia vuoto per tornare al nome suggerito.`)
};

/**
* | output |
* | --- |
* | "Leave it blank to go back to the suggested name." |
*
* @param {Plan_Rename_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_rename_helper = /** @type {((inputs?: Plan_Rename_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Rename_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_rename_helper(inputs)
	if (locale === "es-419") return es_419_plan_rename_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_rename_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_rename_helper(inputs)
	if (locale === "de-DE") return de_de2_plan_rename_helper(inputs)
	if (locale === "it-IT") return it_it2_plan_rename_helper(inputs)
	return en_us2_plan_rename_helper(inputs)
});
export { plan_rename_helper as "plan.rename_helper" }